import {connect} from 'react-redux';
import SimPrice from './SimPrice';
import {simProductPriceSelector} from '../../../../modules/SignUp/Sim/selectors';
import {
  eSimSelectedSelector,
  esimProductSelector,
} from '../../../../modules/ESim';

const mapStateToProps = state => ({
  simPrice: simProductPriceSelector(state),
  eSimPrice: esimProductSelector(state),
  eSimSelected: eSimSelectedSelector(state),
});

export default connect(mapStateToProps)(SimPrice);
